import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { MatDialogModule, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { FlexLayoutModule } from '@angular/flex-layout';
import { combineLatest, lastValueFrom } from 'rxjs';
import { debounceTime, startWith, switchMap } from 'rxjs/operators';
import { CampaignsCampaignAdminApiClient, FuzzyTestRequest, FuzzyTestResponse } from 'src/app/api/api-campaigns.service.generated';
import { ButtonComponent } from "wecheer-common";

@Component({
  selector: 'app-fuzzy-test',
  templateUrl: './fuzzy-test.component.html',
  styleUrls: ['./fuzzy-test.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTableModule,
    FlexLayoutModule,
    ButtonComponent
  ]
})
export class FuzzyTestComponent implements OnInit {
  private api = inject(CampaignsCampaignAdminApiClient);
  dialogRef = inject<MatDialogRef<FuzzyTestComponent>>(MatDialogRef);


  static async open(dialog: MatDialog) {
    return await lastValueFrom(dialog.open(FuzzyTestComponent, { width: '600px' }).afterClosed());
  }

  form = new FormGroup({
    text1: new FormControl(''),
    text2: new FormControl(''),
  });

  isLoading: boolean;

  testResults: any[];

  ngOnInit() {

    combineLatest([
      this.form.controls.text1.valueChanges.pipe(startWith('')),
      this.form.controls.text2.valueChanges.pipe(startWith(''))
    ])
      .pipe(
        debounceTime(500),
        switchMap(([text1, text2]) => {
          this.isLoading = true;
          return this.api.fuzzyTest(new FuzzyTestRequest({ text1, text2 }));
        })
      )
      .subscribe((res: FuzzyTestResponse) => {
        this.testResults = res.scoreByAlgorithm
          ? Object.keys(res.scoreByAlgorithm).map(key => {
            return { algorithm: key, score: res.scoreByAlgorithm[key] };
          })
          : [];

        this.isLoading = false;
      });
  }

  onClose() {
    this.dialogRef.close(undefined);
  }


}
